import { ChangeDetectorRef, Component, OnInit, ViewRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CardView } from 'src/app/interfaces/cardview';

@Component({
    selector: 'app-integracao-melhor-envio',
    templateUrl: './integracao-melhor-envio.component.html',
    styleUrls: ['./integracao-melhor-envio.component.scss'],
    standalone: false
})
export class IntegracaoMelhorEnvioComponent implements OnInit {

  constructor(private routerParam:ActivatedRoute, private cd:ChangeDetectorRef) {

    this.table_name = this.routerParam.snapshot.data["table_name"];
    this.entityDesc = this.routerParam.snapshot.data["entityDesc"];
   }

  ngOnInit(): void {
  }

  options:Object[] = [];
  table_name;
  entityDesc;
  title:string = "NAME";
  img:string = "IMAGE";
  pk:string ="INTERNALID"
  editface = false;
  row:CardView;
  columns = [{name:"CUSTOMERNAME", desc:"Nome do Cliente"},{name:"ORDERID", desc:"Nro. Pedido"}];

  config:{columnName:string, fontName:string, fontSize:string, fontWeight:string, row:number,column:number, descName:string, fontColor:string}[] = [
    {
      columnName:"ORDERID",
      fontName:"Arial, Helvetica, sans-serif",
      fontWeight:"bold",
      row:1,
      column:2,
      fontSize:"20px",
      descName:"Nro. Pedido",
      fontColor: "red"
  },
  {
  columnName:"MKTPLACE",
  fontName:"Arial, Helvetica, sans-serif",
  fontWeight:"bold",
  row:1,
  column:3,
  fontSize:"14px",
  descName:"MarketPlace",
  fontColor: "blue"
},
{
  columnName:"CODECOMPANY",
  fontName:"Arial, Helvetica, sans-serif",
  fontWeight:"bold",
  row:1,
  column:5,
  fontSize:"14px",
  descName:"Empresa",
  fontColor: "blue"
},
{
  columnName:"CODECONTRACT",
  fontName:"Arial, Helvetica, sans-serif",
  fontWeight:"bold",
  row:1,
  column:3,
  fontSize:"14px",
  descName:"Cód. Contrato",
  fontColor: "blue"
},
{
  columnName:"NAME",
  fontName:"Arial, Helvetica, sans-serif",
  fontWeight:"bold",
  row:1,
  column:3,
  fontSize:"14px",
  descName:"Nome do Produto",
  fontColor: "blue"
}
]


clickedRow(row:CardView){
  this.row = row;
  setTimeout(()=>{
    this.editface = true;

    setTimeout(() => {
      if (this.cd !== null && this.cd !== undefined &&
        !(this.cd as ViewRef).destroyed) {
        this.cd.detectChanges();
      }
      }, 250);
    
  },700)
  
}
}
